import { type MailRibbonGroupId, type MailRibbonTabId } from 'owa-ribbon-ids/lib/mailRibbonId';
import Flag from 'owa-fluent-icons-svg/lib/icons/FlagRegular';
import FolderArrowRight from 'owa-fluent-icons-svg/lib/icons/FolderArrowRightRegular';
import {
    find_GroupButton as GroupStrings_find_GroupButton,
    move_GroupButton as GroupStrings_move_GroupButton,
    tags_GroupButton as GroupStrings_tags_GroupButton,
} from 'owa-locstrings/lib/strings/ribbon_mail_groups.locstring.json';
import type { MenuDefinition, RibbonFlyoutAnchorProps } from 'owa-acui';
import type { ReadOnlyRibbonControlDefProps } from 'owa-mail-ribbon-utils';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import Search from 'owa-fluent-icons-svg/lib/icons/SearchRegular';
import { owaComputedFn } from 'owa-computed-fn';
import { constructKeytip } from 'owa-command-ribbon';
import { createMailAppFlyoutAnchor } from 'owa-mail-ribbon-utils/lib/createMailRibbonButton';
import { getRibbonMailboxInfo } from 'owa-mail-ribbon-utils/lib/getRibbonMailboxInfo';
import loc from 'owa-localize';

const emptyMenuDefinition: MenuDefinition = {
    sections: [],
};

export const getMLRHomeTabCommonGroupFlyout: (
    groupId: RibbonGroupId,
    props: ReadOnlyRibbonControlDefProps
) => RibbonFlyoutAnchorProps | undefined = owaComputedFn(function getMLRHomeTabCommonGroupFlyout(
    groupId: RibbonGroupId,
    props: ReadOnlyRibbonControlDefProps
): RibbonFlyoutAnchorProps | undefined {
    const mailboxInfo = getRibbonMailboxInfo(props.mailboxInfo);
    switch (groupId) {
        case 108:
            return createMailAppFlyoutAnchor(
                groupId,
                loc(GroupStrings_find_GroupButton),
                undefined /*tooltip*/,
                props,
                emptyMenuDefinition,
                mailboxInfo,
                constructKeytip([1], 108),
                Search
            );

        case 113:
            return createMailAppFlyoutAnchor(
                groupId,
                loc(GroupStrings_move_GroupButton),
                undefined /*tooltip*/,
                props,
                emptyMenuDefinition,
                mailboxInfo,
                constructKeytip([1], 113),
                FolderArrowRight
            );

        case 128:
            return createMailAppFlyoutAnchor(
                groupId,
                loc(GroupStrings_tags_GroupButton),
                undefined /*tooltip*/,
                props,
                emptyMenuDefinition,
                mailboxInfo,
                constructKeytip([1], 128),
                Flag
            );

        default:
            return undefined;
    }
});
